import { render, staticRenderFns } from "./GuestAvatar.vue?vue&type=template&id=5f1a8424&scoped=true&"
import script from "./GuestAvatar.vue?vue&type=script&lang=js&"
export * from "./GuestAvatar.vue?vue&type=script&lang=js&"
import style0 from "./GuestAvatar.vue?vue&type=style&index=0&id=5f1a8424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1a8424",
  null
  
)

export default component.exports